import { useMutation, useQueryClient } from "@tanstack/react-query";
import { configuration } from "src/configuration";
import { FetchError, queryKeys, useAccessToken } from "src/http";

type Variables = {
  azureDevOpsWorkItemCollectionGuid: string;
  workItemId: number;
};

const useRemoveAzureDevOpsWorkItemFromCollectionRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function removeAzureDevOpsWorkItemFromCollection(variables: Variables) {
    const accessToken = await getAccessToken();

    const response = await fetch(
      `${configuration.apiRootUrl}/azure-devops-work-item-collections/${variables.azureDevOpsWorkItemCollectionGuid}/work-items/${variables.workItemId}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        method: "delete",
      }
    );

    if (!response.ok) {
      throw new FetchError(response);
    }
  }

  return { removeAzureDevOpsWorkItemFromCollection };
};

const useRemoveAzureDevOpsWorkItemFromCollection = () => {
  const { removeAzureDevOpsWorkItemFromCollection } = useRemoveAzureDevOpsWorkItemFromCollectionRequest();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: removeAzureDevOpsWorkItemFromCollection,
    onSuccess: async (_data, variables) => {
      await queryClient.removeQueries({
        queryKey: queryKeys.azureDevOpsWorkItems.getAzureDevOpsWorkItemCollection(
          variables.azureDevOpsWorkItemCollectionGuid
        ),
      });
    },
  });
};

export { useRemoveAzureDevOpsWorkItemFromCollection };
